import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'portals-thank-you-after',
	templateUrl: './thank-you-after.component.html',
	styleUrls: ['./thank-you-after.component.scss'],
})
export class ThankYouAfterComponent implements OnInit {
	constructor(private router: Router) {}
	goToSendMessage() {
		this.router.navigate(['/send-message']);
	}
	ngOnInit(): void {}
}
